import { HttpService } from '@/infra/http'
import type { TCliente } from '@/types/cliente'

export class GetClienteCpfService extends HttpService {
  async execute({ cpf }: { cpf: string }) {
    return this.http.get<TCliente>(`api/v2/Cliente/obterParaProposta/${cpf}`)
  }
}
